




















import { computed, defineComponent, useContext } from '@nuxtjs/composition-api';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useEnotecaApp } from '~/composables/useEnotecaApp';
import { useMatchMedia } from '~/composables/useMatchMedia';
import { CollegeLessonStatus } from '~/enums';

export default defineComponent({
  components: {
    AppLink,
  },
  props: {
    // 受講ステータスを表示するか
    noStatus: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { i18n } = useContext();
    const { isDesktop } = useMatchMedia();
    const { isEnotecaAppWebView } = useEnotecaApp();
    const tag = computed(() => (isEnotecaAppWebView.value ? 'a' : undefined));

    const statusInfo = computed(() => {
      switch (props.status) {
        case CollegeLessonStatus.PROGRESS:
          return {
            text: i18n.t('College-01.status.working').toString(),
            bgColor: 'bg-Black88',
          };
        case CollegeLessonStatus.COMPLETED:
          return {
            text: i18n.t('College-01.status.done').toString(),
            bgColor: 'bg-status-gray',
          };
        default:
          return {
            text: i18n.t('College-01.status.waiting').toString(),
            bgColor: 'bg-Black88',
          };
      }
    });

    return { statusInfo, isDesktop, tag };
  },
});
